// client/src/utils/fetchPhaseClasses.js
import { fetchJson } from './fetchJson';

/**
 * Fetch classes filtered by phase (strict by default).
 * When allowEmptyFallback is true and the strict list is empty, it will return classes across phases (still school-scoped).
 */
export async function fetchPhaseClasses(phaseCode, { allowEmptyFallback = false } = {}) {
  const phase = (phaseCode || '').toString();
  try {
    const data = await fetchJson(`/api/classes-lite?phase=${encodeURIComponent(phase)}`);
    let list = data?.classes || data?.data || data || [];
    if (!Array.isArray(list)) list = [];
    if (list.length === 0 && allowEmptyFallback) {
      const data2 = await fetchJson('/api/classes-lite?anyPhase=1');
      let list2 = data2?.classes || data2?.data || data2 || [];
      if (!Array.isArray(list2)) list2 = [];
      return list2;
    }
    return list;
  } catch (e) {
    // Bubble up or convert to [] based on preference
    throw e;
  }
}
